/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BalanceDto } from './balanceDto';

/**
 * Account balances with global credit information.
 */
export interface AccountBalanceDto {
  creditLimit: number;
  usedCreditLimit: number;
  usdNotional: number;
  /**
   * Asset balances
   */
  assetBalances: Array<BalanceDto>;
}
